import React from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import pluralize from 'lib/pluralize'
import { calculateStripeFee } from 'lib/stripe'
import { currency } from 'lib/utils/string'
import useStyles from './group-event-registration-form.styles'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const PriceDetails = ({ groupEvent, paymentRequired }) => {
  const classes = useStyles()
  const { watch } = useFormContext()
  const participants = watch('participants')

  const [isStripeFlatFeeDeducted] = useFeatureFlags([
    flags.FLAT_FEAT_STRIPE_FEE_DEDUCTED,
  ])

  const registrationFeeAmountInCents =
    groupEvent.priceInCents * participants.length
  const processingFeeAmountInCents = isStripeFlatFeeDeducted
    ? 0
    : calculateStripeFee(registrationFeeAmountInCents)

  const priceInDollars = groupEvent.priceInCents / 100
  const registrationFeeAmountInDollars = registrationFeeAmountInCents / 100
  const processingFeeAmountInDollars = processingFeeAmountInCents / 100

  return (
    <>
      <Box mb={2}>
        <Typography
          variant="subtitle1"
          className={classes.formSectionSubheader}
        >
          Price details
        </Typography>
      </Box>
      <Box
        color="text.secondary"
        display="flex"
        justifyContent="space-between"
        mb={0.5}
      >
        <Typography variant="body1">
          {currency(priceInDollars)} x {participants.length}{' '}
          {pluralize(participants.length, 'participant')}
        </Typography>
        <Typography variant="body1">
          {currency(registrationFeeAmountInDollars)}
        </Typography>
      </Box>
      {paymentRequired ? (
        <>
          {!isStripeFlatFeeDeducted && (
            <Box
              color="text.secondary"
              display="flex"
              justifyContent="space-between"
              mb={0.5}
            >
              <Typography variant="body1">Processing Fee</Typography>
              <Typography variant="body1">
                {currency(processingFeeAmountInDollars)}
              </Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="space-between" mt={2}>
            <Typography variant="subtitle1">Due today</Typography>
            <Typography variant="subtitle1">
              {currency(
                registrationFeeAmountInDollars + processingFeeAmountInDollars,
              )}
            </Typography>
          </Box>
        </>
      ) : (
        <>
          <Box
            color="text.secondary"
            display="flex"
            justifyContent="space-between"
            mb={0.5}
          >
            <Typography variant="body1">Tax</Typography>
            <Typography variant="body1">–</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography variant="body1">Total</Typography>
            <Typography variant="body1">
              {currency(registrationFeeAmountInDollars)}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={0.5}>
            <Box>
              <Typography variant="subtitle1">Due today</Typography>
              <Box
                color="text.secondary"
                display="flex"
                justifyContent="space-between"
              >
                <Typography variant="caption">
                  Pay at location, state and local taxes may apply
                </Typography>
              </Box>
            </Box>
            <Typography variant="subtitle1">$0.00</Typography>
          </Box>
        </>
      )}
    </>
  )
}

export default PriceDetails
